import { isIndiaCountry } from './region';

export const PRICING_PLAN_KEYS = [
  'free', 'standard', 'standard_india', 'plus', 'pro', 'unlimited', 'enterprise',
] as const;

export type PricingPlanKey = typeof PRICING_PLAN_KEYS[number];

export const getPlanBillingInterval = (tier: string, isAnnual: boolean): 'monthly' | 'annual' => (
  isAnnual && tier.trim().toLowerCase() !== 'unlimited' ? 'annual' : 'monthly'
);

const STANDARD_PLAN_KEYS = new Set<string>(['standard', 'standard_india']);
const DISPLAY_PLAN_ORDER: PricingPlanKey[] = ['free', 'standard', 'plus', 'pro', 'unlimited', 'enterprise'];

const PRICING_PLAN_RANK: Record<string, number> = {
  free: 0,
  trial: 0,
  standard: 1,
  standard_india: 1,
  byok: 1,
  plus: 2,
  pro: 3,
  unlimited: 4,
  enterprise: 5,
};

export const getPricingPlanRank = (tier?: string | null): number => {
  const key = (tier || 'free').trim().toLowerCase();

  return PRICING_PLAN_RANK[key] ?? PRICING_PLAN_RANK.free;
};

export const getRegionalStandardPlanKey = (
  currentTier?: string | null,
  country?: string | null,
): PricingPlanKey => {
  const normalizedTier = (currentTier || '').trim().toLowerCase();
  if (STANDARD_PLAN_KEYS.has(normalizedTier)) return normalizedTier as PricingPlanKey;

  return isIndiaCountry(country) ? 'standard_india' : 'standard';
};

export const getVisiblePricingPlanKeys = (
  currentTier?: string | null,
  country?: string | null,
): PricingPlanKey[] => {
  const standardKey = getRegionalStandardPlanKey(currentTier, country);
  const displayPlanOrder = DISPLAY_PLAN_ORDER.map((planKey) => (
    planKey === 'standard' ? standardKey : planKey
  ));

  return displayPlanOrder;
};
